import {forwardRef} from 'react'
import type {CSSProperties, MouseEventHandler, ReactNode} from 'react'
import {TableRow} from '@/components/ui/table'
import {cn} from '@/lib/utils'

interface SortableTableRowProps {
    dragStyle?: CSSProperties
    clickable?: boolean
    alternateBg?: boolean
    children?: ReactNode
    onClick?: MouseEventHandler<HTMLTableRowElement>
    'data-testid'?: string
}

export const SortableTableRow = forwardRef<HTMLTableRowElement, SortableTableRowProps>(
    ({dragStyle, clickable, alternateBg, children, onClick, 'data-testid': testId}, ref) => (
        <TableRow
            ref={ref}
            className={cn(
                clickable && 'cursor-pointer hover:bg-muted/50',
                alternateBg && 'bg-muted/40',
            )}
            onClick={onClick}
            style={dragStyle}
            data-testid={testId}
        >
            {children}
        </TableRow>
    ),
)
SortableTableRow.displayName = 'SortableTableRow'
